import React from 'react';
import { Alert, Typography } from 'antd';

const { Text, Paragraph } = Typography;

/**
 * Compact in-product guide for org Manage plans / Add plan.
 * Full write-up: docs/MANAGE_ORG_PLANS_QUICK_GUIDE.md
 */
export default function ManageOrgPlansGuide({ compact = false }) {
  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
      message="Manage plans — quick guide"
      description={(
        <div className="manage-org-plans-guide">
          <Paragraph style={{ marginBottom: 8 }}>
            This screen assigns <Text strong>plan types</Text> to the organization
            (what members can enroll on). It is not member enrollment.
          </Paragraph>

          <Paragraph style={{ marginBottom: 4 }}>
            <Text strong>What appears in Add plan</Text>
          </Paragraph>
          <ul style={{ margin: '0 0 8px', paddingLeft: 18 }}>
            <li>Corporate plans — yes</li>
            <li>Both (corporate + retail) — yes</li>
            <li>Retail-only — no</li>
            <li>Utility / archived — no</li>
          </ul>

          <Paragraph style={{ marginBottom: 8 }}>
            <Text strong>Bands and pricing</Text>
            {' '}After choosing a plan, tick the bands and sub-bands this organization gets. Each starts at its
            {' '}base price from the main Plan section; type a different amount where the organization has an agreed
            {' '}price. Prices set here apply to this organization only. Use <Text strong>Bands &amp; pricing</Text> on
            {' '}an assigned plan to add, remove or re-price sub-bands later.
          </Paragraph>

          <Paragraph style={{ marginBottom: compact ? 0 : 8 }}>
            <Text strong>Need a retail plan here?</Text>
            {' '}Open <Text code>Plans → Catalog</Text>, set that plan’s audience to
            {' '}<Text strong>Corporate</Text> or <Text strong>Both</Text>, then return.
          </Paragraph>

          {!compact ? (
            <Paragraph style={{ marginBottom: 0 }} type="secondary">
              Admin adds apply immediately. HR requests go through Plans → Plan requests instead.
            </Paragraph>
          ) : null}
        </div>
      )}
    />
  );
}
